const getTitle = (state) => state?.common?.title;
const getHasNewNotifications = (state) => !!state?.dashboard?.notifications;
const getHasNewMessages = (state) => {
  const messages = state?.dashboard?.messages || [];
  return !!Object.values(messages).reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0,
  );
};
const getHasNewCommunityThreadsWithUpdates = (state) => {
  const messages = state?.dashboard?.communityThreadsWithUpdates || [];
  return !!Object.values(messages).reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0,
  );
};

export {
  getTitle,
  getHasNewNotifications,
  getHasNewMessages,
  getHasNewCommunityThreadsWithUpdates,
};
